import {AssertUtils} from "../common/Utils";

class User {
    constructor(email, activities, isOwner) {
        AssertUtils.assertDefined(email, activities, isOwner);
        this.email = email;
        this.activities = activities;
        this.isOwner = isOwner;

        this.routesWiredUp = false;
    }

    static fromMetadata(metadata) {
        const activities = metadata.activities.map(a => new UserActivity({
            type: a.type,
            route: a.route,
            timestamp: new Date(a.timestamp),
        }));
        activities.sort((a1, a2) => a1.timestamp - a2.timestamp);

        return new User(metadata.email, activities, metadata.isOwner);
    }

    wireUpWallRoutes(wall) {
        if (this.routesWiredUp)
            return;
        this.routesWiredUp = true;

        const wallRoutes = Object.fromEntries(wall.routes.map(r => [r.id, r]))
        for (let activity of this.activities) {
            if (activity.route.id in wallRoutes) {
                activity.wallRoute = wallRoutes[activity.route.id];
            }
        }
    }

    getRouteClimbingState(route) {
        for (let i = this.activities.length - 1; i >= 0; i--) {
            const activity = this.activities[i];
            if (activity.route.id === route.id &&
                [UserActivityType.Attempt, UserActivityType.Climb, UserActivityType.Flash].includes(activity.type)
            ) {
                return RouteStateType.fromLastActivity(activity.type);
            }
        }
        return RouteStateType.Untouched;
    }

    getRoutesClimbingStates(routes) {
        const states = new Array(routes.length).fill(RouteStateType.Untouched);
        const idToIdx = new Map(
            Array.from({length: routes.length}, (_, i) => [routes[i].id, i])
        );
        for (let i = this.activities.length - 1; i >= 0; i--) {
            const activity = this.activities[i];
            if (activity.route.id !== undefined &&
                [UserActivityType.Attempt, UserActivityType.Climb, UserActivityType.Flash].includes(activity.type) &&
                idToIdx.has(activity.route.id)
            ) {
                const idx = idToIdx.get(activity.route.id);
                if (states[idx] === RouteStateType.Untouched) {
                    states[idx] = RouteStateType.fromLastActivity(activity.type);
                }
            }
        }
        return states;
    }

    isRouteBookmarked(route) {
        return this.activities.some(a => a.route.id === route.id && a.type === UserActivityType.Bookmark);
    }

    shallowClone() {
        const clone = new User(this.email, this.activities, this.isOwner);
        clone.routesWiredUp = this.routesWiredUp;
        return clone;
    }

    clone() {
        const clone = new User(this.email, this.activities.slice(), this.isOwner);
        clone.routesWiredUp = this.routesWiredUp;
        return clone;
    }
}


class UserActivity {
    constructor({type, timestamp, route, wallRoute = null}) {
        AssertUtils.assertDefined(type, timestamp, route);
        this.type = type;
        this.timestamp = timestamp;
        this.route = route;
        this.wallRoute = wallRoute;
    }
}

class UserActivityType {
    static Attempt = 0;
    static Climb = 1;
    static Flash = 2;
    static Bookmark = 3;
}

class RouteStateType {
    static Attempted = 0;
    static Climbed = 1;
    static Flashed = 2;
    static Untouched = "untouched";

    static fromLastActivity(userActivityType) {
        console.assert([UserActivityType.Attempt, UserActivityType.Climb, UserActivityType.Flash].includes(userActivityType))
        return userActivityType;
    }
}

export {User, UserActivity, UserActivityType, RouteStateType};